import React from 'react'
import {
    Outlet,
} from 'react-router-dom'
import NavBar from '../../components/global/navbar'


function AuthLayout() {
    return (
        <div>
            <NavBar />
            <Outlet />
        </div>

    )
}

export default AuthLayout